import * as yup from 'yup';
import {
    regexPhoneNumber,
    regexStringWithoutEmojiAndSpecialCharater,
    regexValidString,
} from '../../../statics/regex.constant';
import {isValidDate} from '../../../../../utils/date';

export const vuonConcert2025FormSchema = (hasRegionWardSupport: boolean = true) => {
    const baseSchema = {
        email: yup.string().required('Vui lòng nhập email').email('Email không đúng định dạng'),
        fullName: yup
            .string()
            .required('Vui lòng nhập họ và tên')
            .matches(regexStringWithoutEmojiAndSpecialCharater, 'Họ và tên không đúng định dạng'),
        telephone: yup
            .string()
            .required('Vui lòng nhập số điện thoại')
            .matches(regexPhoneNumber, 'Số điện thoại không đúng định dạng'),
        birthday: yup
            .string()
            .required('Vui lòng nhập ngày sinh')
            .test('is-valid-date', 'Ngày sinh không hợp lệ', value => {
                if (!value) {
                    return false;
                }

                return isValidDate(value);
            }),
        participantType: yup
            .object()
            .shape({
                value: yup.string().required('Vui lòng chọn đối tượng tham gia'),
                label: yup.string().required('Vui lòng chọn đối tượng tham gia'),
            })
            .required(),
        ticketExchangeStore: yup
            .object()
            .shape({
                value: yup.string().required('Vui lòng chọn địa điểm đổi vé cứng'),
                label: yup.string().required('Vui lòng chọn địa điểm đổi vé cứng'),
            })
            .required(),
        // Thêm validation cho 2 checkbox bắt buộc
        termsOfService: yup
            .boolean()
            .oneOf([true], 'Bạn phải đồng ý với điều khoản sử dụng')
            .required('Bạn phải đồng ý với điều khoản sử dụng'),
        mediaConsent: yup
            .boolean()
            .oneOf([true], 'Bạn phải đồng ý với việc sử dụng hình ảnh')
            .required('Bạn phải đồng ý với việc sử dụng hình ảnh'),
    };

    // Chỉ thêm validation cho region, ward và street khi có hooks support
    if (hasRegionWardSupport) {
        return yup.object().shape({
            ...baseSchema,
            region: yup
                .object()
                .shape({
                    id: yup.number().moreThan(0, 'Vui lòng chọn tỉnh/thành').required('Vui lòng chọn tỉnh/thành'),
                    value: yup.string().trim().required('Vui lòng chọn tỉnh/thành'),
                    label: yup.string().trim().required('Vui lòng chọn tỉnh/thành'),
                })
                .required('Vui lòng chọn tỉnh/thành'),
            ward: yup
                .object()
                .shape({
                    value: yup.number().moreThan(0, 'Vui lòng chọn phường/xã').required('Vui lòng chọn phường/xã'),
                    label: yup.string().trim().required('Vui lòng chọn phường/xã'),
                })
                .required('Vui lòng chọn phường/xã'),
            street: yup
                .string()
                .required('Vui lòng nhập địa chỉ')
                .min(5, 'Địa chỉ phải có ít nhất 5 ký tự')
                .matches(regexValidString, 'Địa chỉ không đúng định dạng'),
        });
    }

    return yup.object().shape(baseSchema);
};
